// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Fonts/PPNeueBit-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Fonts/N27-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/Images/CA_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/Images/bigbtn.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/Images/CA_Bottombg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: PP-Nuebit;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
    font-family: N27;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.pop-frame{
    background: #ffffff;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 87%;
    height: 91%;
    margin-top: 0;
    min-width: 1050px;

}

.pop-frame .pop-left{
    /* position: absolute; */
width: 45%;
height: 92%;
background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
background-size: 100% 100%;
background-repeat: no-repeat;
display: flex;
align-items: center;
justify-content: center;
min-width: 450px;
}

.pop-frame .pop-left img{
    width: 80%;
}

.pop-frame .pop-right{
width: 50%;
height: 92%;
left: 669.8px;
top: 25.79px;
background:#ffffff;
min-width: 500px
}

.pop-frame .pop-right .pop-right-top{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    text-align: left;
    padding: 0 25px;
    background: #FFFFFF;
    /* height: 45%; */
    padding-bottom: 25px;
    align-items: flex-start;
    height: 44%;
}


.pop-name{
    font-family: PP-Nuebit;
font-size: 4.9vw;
font-weight: 700;
line-height: 81px;
letter-spacing: 0em;
text-align: left;
margin: 0;
margin-bottom:24px;
width: 100%;
}

.pop-desc{
    width: 40%;
    margin-top: 0;
    min-width: 225px;
}

.pop-right-top :nth-child(4n){
    margin-top: 0;
}

.descriptions{
    font-family: 'N27';
    font-style: italic;
    font-weight: 700;
    font-size: 16px;
    line-height: 27px;
    margin: 0 0px 20px 0;
    width: 95%;
}

.description-title{
    font-family: 'N27';
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 19px;
    margin: 0;
}

.linked-in-btn{
    margin: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    color: white;
    padding: 11px;
    width: 70%;
    text-align: center;
    font-family: 'PP-Nuebit';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 26px;
    padding-top: 15px;
    background-size: 100% 100%;
    cursor: pointer;
}

.pop-frame .pop-right .pop-right-bottom{
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
    padding: 0 25px;
    margin-top: 0;
    height: 48%;
    background-size: 100% 100%;
    padding-bottom: 25px;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    
}

.rarity{
    BACKGROUND: #D3B0FF;
    width: 40%;
    font-family: 'N27';
font-style: italic;
font-weight: 700;
font-size: 16px;
line-height: 27px;
    /* margin: 0; */
    text-align: center;
    padding: 10px;
}

.pop-right .pop-right-bottom .nft-title{
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/CApopUp/CApopUp.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,4CAAiD;AACrD;;AAEA;IACI,gBAAgB;IAChB,4CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,aAAa;IACb,iBAAiB;;AAErB;;AAEA;IACI,wBAAwB;AAC5B,UAAU;AACV,WAAW;AACX,yDAAsD;AACtD,0BAA0B;AAC1B,4BAA4B;AAC5B,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,gBAAgB;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;AACA,UAAU;AACV,WAAW;AACX,aAAa;AACb,YAAY;AACZ,kBAAkB;AAClB;AACA;;AAEA;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;AACf;;;AAGA;IACI,sBAAsB;AAC1B,gBAAgB;AAChB,gBAAgB;AAChB,iBAAiB;AACjB,mBAAmB;AACnB,gBAAgB;AAChB,SAAS;AACT,kBAAkB;AAClB,WAAW;AACX;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;IACb,SAAS;AACb;;AAEA;IACI,SAAS;IACT,yDAAuD;IACvD,YAAY;IACZ,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,WAAW;IACX,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,yDAA4D;;AAEhE;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;IACb,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf","sourcesContent":["@font-face {\n    font-family: PP-Nuebit;\n    src: url(\"../../assets/Fonts/PPNeueBit-Bold.otf\");\n}\n\n@font-face {\n    font-family: N27;\n    src: url(\"../../assets/Fonts/N27-Regular.otf\");\n}\n\n.pop-frame{\n    background: #ffffff;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-content: center;\n    width: 87%;\n    height: 91%;\n    margin-top: 0;\n    min-width: 1050px;\n\n}\n\n.pop-frame .pop-left{\n    /* position: absolute; */\nwidth: 45%;\nheight: 92%;\nbackground-image: url(\"../../assets/Images/CA_bg.png\");\nbackground-size: 100% 100%;\nbackground-repeat: no-repeat;\ndisplay: flex;\nalign-items: center;\njustify-content: center;\nmin-width: 450px;\n}\n\n.pop-frame .pop-left img{\n    width: 80%;\n}\n\n.pop-frame .pop-right{\nwidth: 50%;\nheight: 92%;\nleft: 669.8px;\ntop: 25.79px;\nbackground:#ffffff;\nmin-width: 500px\n}\n\n.pop-frame .pop-right .pop-right-top{\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    text-align: left;\n    padding: 0 25px;\n    background: #FFFFFF;\n    /* height: 45%; */\n    padding-bottom: 25px;\n    align-items: flex-start;\n    height: 44%;\n}\n\n\n.pop-name{\n    font-family: PP-Nuebit;\nfont-size: 4.9vw;\nfont-weight: 700;\nline-height: 81px;\nletter-spacing: 0em;\ntext-align: left;\nmargin: 0;\nmargin-bottom:24px;\nwidth: 100%;\n}\n\n.pop-desc{\n    width: 40%;\n    margin-top: 0;\n    min-width: 225px;\n}\n\n.pop-right-top :nth-child(4n){\n    margin-top: 0;\n}\n\n.descriptions{\n    font-family: 'N27';\n    font-style: italic;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 27px;\n    margin: 0 0px 20px 0;\n    width: 95%;\n}\n\n.description-title{\n    font-family: 'N27';\nfont-style: normal;\nfont-weight: 500;\nfont-size: 14px;\nline-height: 19px;\n    margin: 0;\n}\n\n.linked-in-btn{\n    margin: 0;\n    background-image: url(\"../../assets/Images/bigbtn.png\");\n    color: white;\n    padding: 11px;\n    width: 70%;\n    text-align: center;\n    font-family: 'PP-Nuebit';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 26px;\n    padding-top: 15px;\n    background-size: 100% 100%;\n    cursor: pointer;\n}\n\n.pop-frame .pop-right .pop-right-bottom{\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    justify-content: flex-start;\n    text-align: left;\n    padding: 0 25px;\n    margin-top: 0;\n    height: 48%;\n    background-size: 100% 100%;\n    padding-bottom: 25px;\n    align-items: center;\n    background-image: url(\"../../assets/Images/CA_Bottombg.png\");\n    \n}\n\n.rarity{\n    BACKGROUND: #D3B0FF;\n    width: 40%;\n    font-family: 'N27';\nfont-style: italic;\nfont-weight: 700;\nfont-size: 16px;\nline-height: 27px;\n    /* margin: 0; */\n    text-align: center;\n    padding: 10px;\n}\n\n.pop-right .pop-right-bottom .nft-title{\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
